import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as APIS from "../../../../../services/apis";

export function* handleFetchLabDetails({ payload }) {
  try {
    const res = yield call(APIS.fetchLabDetails, payload);
    const { data } = res;
    yield put(actions.fetchLabDetailsSuccess(data));
  } catch (err) {
    yield put(actions.fetchLabDetailsFailure(err?.response?.data));
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export function* viewLabSaga() {
  yield takeLatest(actions.fetchLabDetails.type, handleFetchLabDetails);
}
